module.exports = __webpack_public_path__ + "static/media/close-icon.e6bfdbf9.svg";